import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

export const ProposalCancelled = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const artworkTitle = location.state?.artworkTitle || t("proposalCancelled.fallbackArtwork");

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <div className="text-center mb-8">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gray-100 text-gray-600 mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
        <h1 className="text-3xl title-artsy mb-2">{t("proposalCancelled.title")}</h1>
        <p className="text-gray-600">{t("proposalCancelled.subtitle", { artwork: artworkTitle })}</p>
      </div>

      <div className="detail-container-artsy mb-8">
        <p className="text-gray-700 mb-4">{t("proposalCancelled.noCharge")}</p>
        <p className="text-gray-700">{t("proposalCancelled.help")}</p>
      </div>

      <div className="flex justify-center mt-8">
        <button onClick={() => navigate("/dashboard")} className="btn-artsy btn-primary-artsy">
          {t("proposalCancelled.back")}
        </button>
      </div>
    </div>
  );
};
